/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { YoutubeVideoConfigInfoRespVo } from './YoutubeVideoConfigInfoRespVo';
import {
    YoutubeVideoConfigInfoRespVoFromJSON,
    YoutubeVideoConfigInfoRespVoFromJSONTyped,
    YoutubeVideoConfigInfoRespVoToJSON,
    YoutubeVideoConfigInfoRespVoToJSONTyped,
} from './YoutubeVideoConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseListYoutubeVideoConfigInfoRespVo
 */
export interface ResponseListYoutubeVideoConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListYoutubeVideoConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListYoutubeVideoConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<YoutubeVideoConfigInfoRespVo>}
     * @memberof ResponseListYoutubeVideoConfigInfoRespVo
     */
    data?: Array<YoutubeVideoConfigInfoRespVo>;
}

/**
 * Check if a given object implements the ResponseListYoutubeVideoConfigInfoRespVo interface.
 */
export function instanceOfResponseListYoutubeVideoConfigInfoRespVo(value: object): value is ResponseListYoutubeVideoConfigInfoRespVo {
    return true;
}

export function ResponseListYoutubeVideoConfigInfoRespVoFromJSON(json: any): ResponseListYoutubeVideoConfigInfoRespVo {
    return ResponseListYoutubeVideoConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponseListYoutubeVideoConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListYoutubeVideoConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(YoutubeVideoConfigInfoRespVoFromJSON)),
    };
}

export function ResponseListYoutubeVideoConfigInfoRespVoToJSON(json: any): ResponseListYoutubeVideoConfigInfoRespVo {
    return ResponseListYoutubeVideoConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponseListYoutubeVideoConfigInfoRespVoToJSONTyped(value?: ResponseListYoutubeVideoConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(YoutubeVideoConfigInfoRespVoToJSON)),
    };
}

